import { inject, Injectable } from '@angular/core';
import { ProgressPlayerHelper } from './progress-player-helper';

export interface ILevelRating{
  level: number,
  points: number,
  maxPoints: number
}

export interface IRating{
  typeId: number,
  levels: Array<ILevelRating>
}

@Injectable({
  providedIn: 'root'
})
export class ProgressPlayerService {
  clearAll() {
    this.systemRating = [];
    this.showLevel = [];
    this.rating = null;
  }
  
  showLevel: Array<number> = [];
  systemRating: Array<IRating> = [];
  rating: IRating | null = null;
  progressHelper = inject(ProgressPlayerHelper);

  fnSetRating(typeId: number, points: number, maxPoints: number, level: number){
    const rating = this.fnFindType(typeId);
    if(!rating){
      this.rating = this.addCard(typeId, points, maxPoints, level);
    }else{
      if(this.fnFindLevel(level)){
        this.update(points, maxPoints, level);
      }else{
        this.addLevel(points, maxPoints, level);
      }
    }
  }

  addCard(typeId: number, points: number, maxPoints: number, level: number): IRating{
    const rating: IRating = {
      typeId,
      levels: [{
      level,
      points,
      maxPoints
      }]
    };

    this.systemRating.push(rating);
    return rating;
  }

  addLevel(points: number, maxPoints: number, level: number){
    if(!this.rating){
      return;
    }

    this.rating.levels.push({
      level: level,
      points,
      maxPoints
    });
  }

  update(points: number, maxPoints: number, level: number){
    if(!this.rating){
      return;
    }

    this.rating.levels.forEach(item =>{
      if(item.level === level){
        item.points = item.points + points;
        item.maxPoints = item.maxPoints + maxPoints;
      }
    });
  }

  collectSendData(level: number){
    this.showLevel.push(level);
    this.updateLevel(level);
    this.sendAllResultBackend();
  }

  progressingThroughLevels(level: number){
    if(!this.showLevel.includes(level)){
      this.showLevel.push(level);
      this.updateLevel(level);
    }
  }

  updateLevel(level: number){
    const rating = this.rating;
    if(!rating){
      return;
    }

    let res = 0;
    const levelRating = this.fnFindLevel(level);
    if(levelRating){    
      const { points, maxPoints } = levelRating;
      if (maxPoints > 0) {
        const ratingPercent = (points / maxPoints) * 100;
        res = parseFloat(ratingPercent.toFixed(2));
      }
    }

    this.progressHelper.setProgress(rating.typeId,res, level);
    
  }

  sendAllResultBackend(){
    this.progressHelper.parseArrayToObject();
    this.progressHelper.saveStorage();
  }

  fnFindType(typeId: number): IRating | null{
    this.rating = this.systemRating.find(item => item.typeId === typeId) ?? null;
    return this.rating;
  }

  fnFindLevel(level: number): ILevelRating | null{
    return this.rating?.levels.find(item => item.level === level) ?? null;
  }

  clearProgressHelper(){
    this.progressHelper.clearProgress();
  }
  
}
